import { nextTick } from 'vue';
import { storeToRefs } from 'pinia';
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { APP_ACCESS_TOKEN_KEY } from '@/utils/constants';

const accessToken = localStorage.getItem(APP_ACCESS_TOKEN_KEY);

export const auth = async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
  const { loggedIn, registerToken, isProfileSetup, isMfaSetup } = storeToRefs(useAuthStore());
  console.log(to.meta.requiresAuth);
  console.log(loggedIn.value);
  if (to.meta.requiresAuth && !loggedIn.value) {
    if (accessToken) {
      return next();
    } else {
      return next(`/login`);
    }
  } else {
    await nextTick();
    // If trying to access /verify without a registerToken, redirect to login
    if (!registerToken.value && to.path === '/verify') {
      return next('/login');
    }

    // If logged in and trying to access auth pages, redirect to home
    if (loggedIn.value && ['/login', '/verify', '/register'].includes(to.path)) {
      return next('/');
    }

    // If registerToken exists, force user to /verify unless already there
    if (registerToken.value && to.path !== '/verify') {
      return next('/verify');
    }

    // If isMfaSetup is true, force user to /security-setup unless already there
    if (isMfaSetup.value && to.path !== '/security-setup') {
      return next('/security-setup');
    }

    // If isProfileSetup is true, force user to /profile-setup unless already there
    if (isProfileSetup.value && to.path !== '/profile-setup') {
      return next('/profile-setup');
    }

    // Otherwise, allow navigation
    return next();
  }
};
